// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JiVo","largestCol":"styles_largestCol__1GibR","smallestCol":"styles_smallestCol__-3UlK"};